<template>
  <div>
    <SoCheckbox
      v-for="(meterpoint, index) in meterpoints"
      :key="meterpoint.id"
      v-model="value"
      :value="String(meterpoint.id)"
      :label="`${meterpoint.isElectricity ? 'Electricity' : 'Gas'} (${
        meterpoint.meterpointType
      } ${meterpoint.identifier})`"
      multiple
      :data-testid="`meterpoint-new-estimate-${index}`"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { useReviewPaymentStore } from "@/stores/reviewPayment"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"

  export default defineComponent({
    components: {
      SoCheckbox,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        reviewPayment: useReviewPaymentStore(),
      }
    },
    computed: {
      value: {
        get() {
          return (
            this.reviewPayment.selectedFuels?.map((meterpoint) =>
              String(meterpoint.id),
            ) ?? [""]
          )
        },
        set(value: string[]) {
          this.reviewPayment.selectedFuels = this.meterpoints.filter(
            (meterpoint) => value.includes(String(meterpoint.id)),
          )
        },
      },
      meterpoints() {
        return this.current.meterpoints.data
      },
    },
    watch: {
      value() {
        this.reviewPayment.selectedEstimates = []
      },
    },
  })
</script>
